module.exports = __webpack_public_path__ + "img/sending_up_red_sparks.0393bde3.jpg";